import { DescripteursEnquete, DescripteursEnqueteRequest } from '@pcscol/odf-api-v1-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

export class ModifierDescripteursEnqueteObjetMaquetteCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private oldDescripteursEnquete: DescripteursEnquete,
        private newDescripteursEnquete: DescripteursEnquete
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierDescripteursEnqueteObjetMaquette(this.id, this.version, this.toRequest(this.newDescripteursEnquete))
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierDescripteursEnqueteObjetMaquette(this.id, this.version, this.toRequest(this.oldDescripteursEnquete))
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }

    private toRequest(value: DescripteursEnquete): DescripteursEnqueteRequest {
        const descripteursSise = { ...(value.descripteursSise ?? {}) } as typeof value.descripteursSise & {
            domaineFormation?: unknown;
        };
        const response = {
            ...value,
            descripteursSise: {
                ...descripteursSise,
                codeDiplomeSise: value.descripteursSise?.codeDiplomeSise?.code,
                codeDiplomeIntermediaireSise: value.descripteursSise?.codeDiplomeIntermediaireSise?.code,
                parcoursTypeSise: value.descripteursSise?.parcoursTypeSise?.code,
                typeDiplome: value.descripteursSise?.typeDiplome?.code,
                domainesFormation: value.descripteursSise?.domainesFormation?.size
                    ? toApiSet(Array.from(value.descripteursSise.domainesFormation, domaine => domaine.code))
                    : undefined,
                champFormation: value.descripteursSise?.champFormation?.code,
                mention: value.descripteursSise?.mention?.code,
                niveauDiplome: value.descripteursSise?.niveauDiplome?.code
            },
            descripteursAglae: value.descripteursAglae!
        };
        return response;
    }
}

// Le contrat généré type un Set, mais le backend attend un tableau JSON.
function toApiSet<T>(values: T[]): Set<T> {
    return (values as unknown) as Set<T>;
}
